import React, { useState } from 'react';
import { Header, Filter, Table, ViewInstanceStatus } from './components';
import { useAutomationStoppedInstance } from '../hooks/useAutomationStoppedInstance';
import { useFilter } from '../hooks/useFilter';
import RunStoppedAutomationModal from './components/RunStoppedAutomationModal';
import GlobalLoader from 'components/GlobalLoader/GlobalLoader';

export default function AutomationStoppedInstanceList() {
  const [selectedInstanceData, setSelectedInstanceData] = useState(null);
  const { filter, refreshList, filterOnChange } = useFilter();
  const { pageSize, paginatorTemplate, stoppedAutomationInstances } = useAutomationStoppedInstance(10, filter);

  const handleCloseModal = () => setSelectedInstanceData(null);
  const isViewAction = selectedInstanceData?.action === 'view';
  const isRunAction = selectedInstanceData?.action === 'run';

  return (
    <div className="container-fluid px-0">
      <GlobalLoader />
      <Header />
      <div className="d-flex flex-wrap align-items-center mb-3 p-1">
        <Filter {...{ filter, refreshList, filterOnChange }} />
      </div>
      <div className="datatable-wrapper">
        <Table
          list={stoppedAutomationInstances}
          pageSize={pageSize}
          paginatorTemplate={paginatorTemplate}
          setSelectedInstanceData={setSelectedInstanceData}
        />
      </div>
      {selectedInstanceData && isViewAction && <ViewInstanceStatus visible onHide={handleCloseModal} instanceData={selectedInstanceData} />}
      {selectedInstanceData && isRunAction && (
        <RunStoppedAutomationModal visible onHide={handleCloseModal} instanceData={selectedInstanceData} />
      )}
    </div>
  );
}
